<template>
    <b-modal
        @ok="generateReport"
        class="pt-8"
        v-model="showModal"
        title="Select Report Type"
    >
        <template #default>
            <b-form class="mt-3">
                <b-form-group label="Report Types" v-slot="{ ariaDescribedby }">
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="detail_report"
                        id="detail_report"
                        >Order Detail Report PDF</b-form-radio
                    >
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="summary_report"
                        id="summary_report"
                        >Order Summary Report PDF</b-form-radio
                    >
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="detail_export"
                        id="detail_export"
                        >Order Detail Export Excel</b-form-radio
                    >
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="summary_export"
                        id="summary_export"
                        >Order Header Export Excel</b-form-radio
                    >
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="service_billing_pdf"
                        id="service_billing_pdf"
                        >Billing Summary Report PDF</b-form-radio
                    >
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="service_billing_excel"
                        id="service_billing_excel"
                        >Billing Summary Report Excel</b-form-radio
                    >
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="officer_details"
                        id="officer_details"
                        >Officer Summary Report</b-form-radio
                    >
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="service_summary_pdf"
                        id="service_summary_pdf"
                        >Billing Detailed Report PDF</b-form-radio
                    >
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="service_summary_excel"
                        id="service_summary_excel"
                        >Billing Detail Report Excel</b-form-radio
                    >
                </b-form-group>

                <b-form-group
                    v-show="reportType === 'detail_report'"
                    label="Select Options"
                    v-slot="{ ariaDescribedby }"
                >
                    <b-form-checkbox
                        v-for="option in rpt_options_props"
                        v-model="rpt_options[option.key]"
                        :key="option.text"
                        :value="option.value"
                        :aria-describedby="ariaDescribedby"
                        name="rpt_optionS_name"
                    >
                        {{ option.text }}
                    </b-form-checkbox>
                </b-form-group>

                <div v-if="!!reportUrl">
                    <a :href="reportUrl" target="_blank" download
                        >Click To Download Report</a
                    >
                </div>
            </b-form>
        </template>

        <template #modal-footer="{ ok, cancel }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button
                size="sm"
                :disabled="!reportType"
                variant="success"
                @click="ok()"
            >
                <b-spinner
                    v-show="loading"
                    variant="primary"
                    label="Spinning"
                ></b-spinner>
                <span v-show="!loading">Create Report</span>
            </b-button>
            <b-button size="sm" variant="danger" @click="cancel()">
                Cancel
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
export default {
    mixins: [popupMixins],
    data() {
        return {
            reportUrl: null,
            showModal: false,
            loading: false,
            reportType: null,

            rpt_options_props: [
                {
                    value: true,
                    key: 'includeAttachments',
                    text: 'include Attachment',
                },
                { value: true, key: 'includeTasks', text: 'Include Tasks' },
                { value: true, key: 'includeNotes', text: 'include Notes' },
            ],

            rpt_options: {
                includeAttachments: true,
                includeTasks: true,
                includeNotes: true,
                includeAuditLogs: false,
            },
        }
    },
    props: ['queryData'],
    computed: {
        baseReportUrl() {
            return this.$store.getters['js_report/reportUrl']
        },
        compositeQuery() {
            const { queryData, reportType: rpt_type, rpt_options } = this
            return {
                ...queryData,
                ...{ rpt_type },
                ...{ rpt_options },
            }
        },
    },

    watch: {
        baseReportUrl: function (url) {
            console.log('report this.compositeQuery', this.compositeQuery)
            console.log('report URL', url)
            this.reportUrl = `${url}&query=${btoa(
                JSON.stringify(this.compositeQuery)
            )}`
        },
        reportType: function () {
            this.reportUrl = null
        },

        rpt_options: function () {
            this.reportUrl = null
        },
        showModal: function () {
            this.reportUrl = null
            this.reportType = null
        },
    },
    methods: {
        show() {
            this.showModal = true
        },
        close() {
            this.showModal = false
        },
        async generateReport(evt) {
            evt.preventDefault()
            try {
                const { reportType: rpt_type } = this
                this.loading = true
                this.$store.dispatch('js_report/fetchCredentials', rpt_type)
            } catch (err) {
                this.doToast(
                    'Error!',
                    'Error Detected. Please consult your System Administrator',
                    'danger'
                )
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<style scoped>
</style>